module.exports = __webpack_public_path__ + "img/img_diaocha.9a99f8c0.jpg";